export const validEmail = (email) => {
  var re = /^[\w+\-.]+@[a-z\d\-.]+\.[a-z]+$/i
  return re.test(email)
}
